/**
 * frontend/src/modules/performance/hooks/useGpsBeginEnd.ts
 * G3 chart 2 conformité begin↔end — 2 hooks :
 *   - useGpsBeginEndScatter() : nuage équipe module.
 *   - useGpsBeginEndMerch(merchCode) : flag/liste visites déplacées drawer.
 *
 * Fenêtre = latest_week (doctrine géo D-GEO-FENETRE-DERNIERE-SEMAINE).
 */

import { useQuery } from '@tanstack/react-query';
import { fetchPerfKpi, fetchMerchSubResource } from '../lib/api';
import type {
  PerfApiResponse,
  GpsBeginEndScatterData,
  GpsBeginEndMerchData,
} from '../types/performance.types';

const STALE = 5 * 60_000;

/**
 * @param pdvType — canal du merch (`merchandiser.channel_type`, ancrage #327).
 *   Omis → le backend défaute à `pdv_type='all'` et n'applique AUCUN filtre canal
 *   (api/service.ts:200 : 'all' → undefined) : retail + wholesale agrégés.
 */
export function useGpsBeginEndScatter(pdvType?: 'retail' | 'wholesale') {
  return useQuery({
    // ⚠ pdvType dans la clé — sinon collision de cache entre appelants.
    queryKey: ['perf-p9', 'gps-begin-end-scatter', pdvType ?? '__all__'] as const,
    queryFn:  () => fetchPerfKpi<GpsBeginEndScatterData>('gps-begin-end', {
      period_preset: 'latest_week',
      ...(pdvType ? { pdv_type: pdvType } : {}),
    }),
    staleTime: STALE,
    retry: 1,
    select: (r: PerfApiResponse<GpsBeginEndScatterData>) => r.data,
  });
}

export function useGpsBeginEndMerch(merchCode: string | null | undefined) {
  return useQuery({
    queryKey: ['perf-p9', 'gps-begin-end-merch', merchCode] as const,
    queryFn:  () => fetchMerchSubResource<GpsBeginEndMerchData>(
      merchCode!, 'gps-begin-end', { period_preset: 'latest_week' },
    ),
    staleTime: STALE,
    retry: 1,
    enabled: !!merchCode,
    select: (r: PerfApiResponse<GpsBeginEndMerchData>) => r.data,
  });
}
